import { graphql } from "./generated/index.js"

// Follows (`record_subscriptions`): a person's explicit follow or unfollow of a
// record. Hasura scopes every row to the signed-in person and presets
// `person_id` on insert, so neither operation names the person.

// The viewer's own row for one record, if any.
export const fetchRecordSubscription = graphql(`
  query fetchRecordSubscription($recordId: Int!) {
    record_subscriptions(where: { record_id: { _eq: $recordId } }, limit: 1) {
      id
      subscribed
    }
  }
`)

// One row per (record, person): a second follow or unfollow flips `subscribed`
// in place. `updated_at` is the table trigger's to stamp.
export const setRecordSubscription = graphql(`
  mutation setRecordSubscription($recordId: Int!, $subscribed: Boolean!) {
    insert_record_subscriptions_one(
      object: { record_id: $recordId, subscribed: $subscribed }
      on_conflict: {
        constraint: record_subscriptions_record_id_person_id_unique
        update_columns: [subscribed]
      }
    ) {
      id
      subscribed
    }
  }
`)
